import React from 'react';
import parse from 'html-react-parser';
import { UiLog, EventName, postUiLog } from '@ecs/tng-common/src/scripts/uilog';
import { useThrottle } from '@ecs/tng-common/src/scripts/helpers';
// interfaces
import { ICard } from '../interfaces/cards';

type CardsApplyButtonProps = {
  card: ICard;
  index: number;
  className?: string;
  analyticsPlacement: string;
  text: string;
};
type CardsApplyButtonState = {
  link: string;
};
class CardsApplyLink extends React.Component<CardsApplyButtonProps, CardsApplyButtonState> {
  private uiLog = new UiLog();

  constructor(props: CardsApplyButtonProps) {
    super(props);
    this.state = {
      link: this.props.card.link
    };
  }

  componentDidMount() {
    const url = new URL(this.props.card.link);
    const params = new URLSearchParams(url.search);
    const newParams: any = this.uiLog.getRedirectLinkParams({
      placement: this.props.analyticsPlacement
    });
    Object.keys(newParams).forEach((key) => params.append(key, newParams[key]));
    url.search = params.toString();
    this.setState({
      link: url.toString()
    });
  }

  postUiLog() {
    postUiLog(EventName.trackLink, {
      identifier: `lg-rightoffer-rank-${this.props.index}`,
      placement: 'rightoffer-listing-view',
      lgplacement: `${this.props.analyticsPlacement}`,
      lgcategory: 'cards',
      lgoffer: `${this.props.card.offerId}:${this.props.card.offerName}`,
      offersource: 'rightoffer',
      lgrank: '0',
      lgrequestid: '',
      offertraits: this.uiLog.returnOfferTraits([this.props.card.offerId]),
      type: 'e'
    });
  }

  render() {
    return (
      <a
        onClick={() => useThrottle(this.postUiLog(), 1000)}
        className={this.props.className}
        href={this.state.link}>
        {parse(this.props.text)}
      </a>
    );
  }
}

export default CardsApplyLink;
